/**
 * Portal de administração: caminho não óbvio (não aparece em menus, sitemap nem robots.txt) e
 * regra de acesso. A segurança real está no Supabase (RLS + app_metadata.role) e nos endpoints
 * /api/admin/*, que validam o papel no servidor — o caminho só evita descobertas casuais.
 */
export const ADMIN_PATH = "/zrs-ops-snmuniw4r";

/** app_metadata só é alterável no servidor/SQL, por isso é seguro para decidir o que mostrar. */
export function isAdminUser(user) {
    return ["admin", "owner"].includes(user?.app_metadata?.role);
}

export function isOwnerUser(user) {
    return user?.app_metadata?.role === "owner";
}
